import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("payeeStore");

const urls = {
  fetchChart: `/merchant/payee/chart`,
  fetchDetails: `/merchant/payee/details`,
  fetchList: (query) => `/merchant/payee/search${query ? `?${query}` : ""}`,
  // cancelLimit: (limitId) => `/bnpl/limit/cancel/${limitId}`,
  // export: `/bnpl/limit/merchant/export`,
};

/**
 * Limit store
 */

const initState = () => {
  return {
    chart: {},
    details: {},
    list: {},
  };
};

const actions = {
  fetchChart: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.post(urls.fetchChart, query);
      commit("saveChart", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchDetails: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.fetchDetails);
      commit("saveDetails", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.fetchList(query));
      commit("saveSearch", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveChart: (state, chart) => {
    Vue.set(state, "chart", chart);
  },
  saveSearch: (state, data) => {
    Vue.set(state, "list", data);
  },
  saveDetails: (state, details) => {
    Vue.set(state, "details", details);
  },
};

const getters = {
  getChart: (state) => {
    return state.chart;
  },
  getList: (state) => {
    return state.list;
  },
  getDetails: (state) => {
    return state.details;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
